// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"TermsAndPrivacyLinks_linksContainer__u44mu"};